var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.271 216.272L256.005 432.542L39.729 216.27C30.642 207.183 15.905 207.181 6.81699 216.272C-2.27201 225.361 -2.27201 240.096 6.81699 249.184L239.55 481.911C243.914 486.275 249.833 488.727 256.005 488.727C262.177 488.727 268.097 486.274 272.46 481.91L505.181 249.183C514.27 240.094 514.27 225.359 505.181 216.271C496.095 207.183 481.358 207.181 472.271 216.272Z",
    fill: "#CA5050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.55 295.729C243.914 300.093 249.833 302.545 256.005 302.545C262.177 302.545 268.097 300.092 272.46 295.728L505.182 63C514.271 53.911 514.271 39.176 505.182 30.088C496.095 20.999 481.358 20.999 472.27 30.088L256.004 246.358L39.729 30.088C30.642 20.999 15.905 20.999 6.81699 30.088C-2.27101 39.177 -2.27201 53.912 6.81699 63L239.55 295.729Z",
    fill: "#CA5050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 511.998,
    height: 511.998,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollArrows);
export default __webpack_public_path__ + "static/media/scroll-arrows.4703edc609d16b5d3ceee2494f069119.svg";
export { ForwardRef as ReactComponent };